module.exports = __webpack_public_path__ + "static/media/Problem Solving.0b09cca0.png";